module.exports = __webpack_public_path__ + "static/media/radio_off.ef5e249e.svg";